import { showAppDialog } from '@/shared/dialogs'
import type { DialogKind, DialogMode } from '@/shared/dialogs/types'

export const MAX_INTERACTION_ROUNDS = 10

const VALID_KINDS = new Set<string>(['Information', 'Warning', 'Error', 'Question'])
const VALID_MODES = new Set<string>(['OK', 'YesNo', 'YesNoCancel', 'OKCancel'])

export interface ServerDialogSpec {
  text: string
  mode: string
  kind: string
}

export function dialogSpecToAppDialogOptions(dialog: ServerDialogSpec) {
  const mode: DialogMode = VALID_MODES.has(dialog.mode)
    ? (dialog.mode as DialogMode)
    : 'OK'
  const kind: DialogKind = VALID_KINDS.has(dialog.kind)
    ? (dialog.kind as DialogKind)
    : 'Information'
  return { text: dialog.text, mode, kind }
}

export async function askInteractionDialog(dialog: ServerDialogSpec): Promise<string> {
  return showAppDialog(dialogSpecToAppDialogOptions(dialog))
}

export async function withInteractionAnswers<T extends Record<string, any>>(
  send: (answers: string[]) => Promise<T>,
  ask: (dialog: ServerDialogSpec) => Promise<string>,
): Promise<T> {
  let answers: string[] = []
  for (let i = 0; i < MAX_INTERACTION_ROUNDS; i++) {
    const res = await send(answers)
    if (!res?.interaction_required) return res
    const dialog = res.dialog
    if (!dialog?.text || !dialog?.mode) throw new Error('Invalid interaction_required response')
    const answer = await ask(dialog)
    answers = [...answers, answer]
  }
  throw new Error('Too many interactive dialogs in one operation')
}
